import { render, staticRenderFns } from "./NlpLeftBackground.vue?vue&type=template&id=535a91a0"
import script from "./NlpLeftBackground.vue?vue&type=script&lang=js"
export * from "./NlpLeftBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports